import format from 'date-fns/format';
import { getDateFormat, getTimeFormat, secsToReadableTime } from '../../common/helpers';
export default class DetailModel {
    /**
     *
     * @param {object} detail
     * @param parent
     */
    constructor(detail, parent) {
        this.key = detail.key;
        this.time = new Date(detail.time);
        this.icons = detail.icons;
        this.params = detail.params;
        this.parent = parent;
    }

    /**
     * Checks this detail for the first in the call trace
     * @returns {boolean}
     */
    isFirst() {
        return this.parent.details[0] === this;
    }

    /**
     * Gets string of start date without time
     * @returns {String}
     */
    getStartSDate() {
        return format(this.time.getTime(), getDateFormat());
    }

    /**
     * Gets string of start time
     * @returns {String}
     */
    getStartSTime() {
        return format(this.time.getTime(), getTimeFormat());
    }

    /**
     * Gets string of Start Date Time
     * @returns {string}
     */
    getStartDateTime() {
        return this.getStartSDate() + ' / ' + this.getStartSTime();
    }

    /**
     * Gets key for translation
     * @returns {string}
     */
    getTranslationKey() {
        return 'reporting.detail.' + this.key;
    }

    /**
     * Gets parameters for pattern translation
     * @returns {string}
     */
    getTranslationParams() {
        return this.params;
    }

    /**
     * Gets string of target time
     * @returns {string}
     */
    getTargetTime() {
        if (!this.isFirst()) {
            return '-';
        }

        let category = this.parent.category;
        if (!category || this !== this.parent.details[0]) {
            return '-';
        }

        return secsToReadableTime(category.target);
    }

    /**
     * is call trace incomplete or without end time?
     * @returns {boolean}
     */
    isUnfinished() {
        return !!this.parent.incomplete || !this.parent.endTime;
    }

    /**
     * Gets string of actual time
     * @returns {string}
     */
    getActualTime() {
        let eventEnd;
        let changeTime;

        if (!this.isFirst()) {
            return '-';
        }

        switch (this.parent.category && this.parent.category.till) {
            case 1:
                eventEnd = this.parent.cacheAccepted;
                break;
            case 2:
                eventEnd = this.parent.cacheNP;
                break;
            case 3: // use end time
            default:
                eventEnd = this.parent.endTime;
        }
        changeTime = this.parent.cacheCatChanged;

        if (eventEnd && !changeTime) {
            let ms = eventEnd.getTime() - this.parent.startTime.getTime();

            return secsToReadableTime(ms / 1000);
        }

        if (eventEnd && changeTime && eventEnd.getTime() <= changeTime.getTime()) {
            let ms = eventEnd.getTime() - this.parent.startTime.getTime();

            return secsToReadableTime(ms / 1000);
        }

        let ms = this.parent.endTime.getTime() - this.parent.startTime.getTime();

        return secsToReadableTime(ms / 1000);
    }

    /**
     * Gets actual message's translation key if call trace is unfinished
     * @returns {string}
     */
    getUnfinishedTranslationKey() {
        if (this.parent.incomplete) {
            return 'reports.unknown';
        } else if (!this.parent.endTime) {
            return 'reports.ongoing';
        }
    }

    /**
     * Gets phone number (Call id)
     * @returns {number}
     */
    getCallId() {
        if (
            [
                'messageSent',
                'callAccepted',
                'callSpeech',
                'callRejected',
                'callParked',
                'callCanceled',
            ].includes(this.key) &&
            this.params.length
        ) {
            return this.params[0];
        }
    }
}
